
<!-- TODO: LANG EN  -->
<li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
	<a class="icon-Shape-3">Miles Card Terms and Conditions</a>
</li>

<a class="icon-Shape-3 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Miles Card Terms and Conditions</a>
<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}" id="item-1">

	<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">MILES CARD TERMS AND CONDITIONS</h2>

	<div class="container" [ngClass]="{'show': show_description1}">
	<p>
		<strong>Miles</strong> card is not a credit card, a debit or a prepaid card. <strong>Miles</strong> card is a hybrid that offers the freedom to combine multiple global currencies, rewards, and all your credit, debit and
		membership cards in one. Every time you use your <strong>Miles</strong> card you are earning miles.
	</p>
	<p>
		The <strong>Miles</strong> Visa Card is issued by Stripe pursuant to a license from Visa Inc and may be used
		everywhere Visa is accepted. Stripe is the Card Network principal issuing member(s) that
		participates in the Program, currently Regions Bank, an Alabama FDIC-insured state bank.
		UpperClub Inc. is a technology services providers and administrators of the card program under
		the <a href="https://stripe.com/card-program/legal" target="_blank">agreement </a> with Stripe and issuer.
	</p>
	</div>
</div>



<!-- TODO: LANG ES  -->
<!-- <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
	<a class="icon-Shape-3">Miles Card Terms and Conditions</a>
</li>

<a class="icon-Shape-3 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Miles Card Terms and Conditions</a>
<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}" id="item-1">

	<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">MILES CARD TERMS AND CONDITIONS</h2>

	<div class="container" [ngClass]="{'show': show_description1}">
	<p>
		<strong>Miles</strong> card is not a credit card, a debit or a prepaid card. <strong>Miles</strong> card is a hybrid that offers the freedom to combine multiple global currencies, rewards, and all your credit, debit and
		membership cards in one. Every time you use your <strong>Miles</strong> card you are earning miles.
	</p>
	<p>
		The <strong>Miles</strong> Visa Card is issued by Stripe pursuant to a license from Visa Inc and may be used
		everywhere Visa is accepted. Stripe is the Card Network principal issuing member(s) that
		participates in the Program, currently Regions Bank, an Alabama FDIC-insured state bank.
		UpperClub Inc. is a technology services providers and administrators of the card program under
		the <a href="https://stripe.com/card-program/legal" target="_blank">agreement </a> with Stripe and issuer.
	</p>
	</div>
</div> -->
